import React from 'react'

import { Button, Modal, SectionSubtitle } from '../..'
import { Spacer } from '../../global'

const ConfirmationModal = ({
  message,
  handleModalClose,
  continueFn,
}: {
  message: string
  handleModalClose: () => void
  continueFn: () => void
}) => {
  return (
    <Modal onClose={() => handleModalClose()}>
      <Spacer height={30} />
      <SectionSubtitle fontSize={16} fontWeight={500} textAlign="center">
        <p>{message}</p>
      </SectionSubtitle>
      <Spacer height={20} />
      <div style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
        <Button
          className="light-grey"
          onClick={() => handleModalClose()}
          label="No"
          fontSize={16}
        />

        <Button
          className="dark-grey"
          onClick={continueFn}
          label="Continuar"
          fontSize={16}
        />
      </div>
    </Modal>
  )
}

export default ConfirmationModal
